export default "//static.tradera.net/touchweb/static/output/images/mastercard_vertical.1baaecdb.svg";